import React from 'react'
import i18n from '@dhis2/d2-i18n'
import { Title } from './Title'

export const TitleDetails = () => <Title label={i18n.t('Details')} />



// WEBPACK FOOTER //
// ./src/pages/resource/add-edit-resource/ResourceForm/TitleDetails.js